import { CreditNoteType, InvoiceCreditNoteType } from 'entities/CreditNote';
import { TableFilterType } from 'features/TableFilter';
import { getFilterServerFormatDate } from 'shared/utils/helpers/getDateFormat';

interface InvoiceListFilters {
  warehouseId?: string;
  creditedAmount?: number;
  creationDateFrom?: string;
  creationDateTo?: string;
  creditNoteType?: CreditNoteType;
  isApplicable?: boolean;
}

export const transformCreditNotesListFilters = ({
  selectedWarehouses,
  creditNoteType,
  creditedAmount,
  creationDateFrom,
  creationDateTo,
  isApplicable,
}: TableFilterType): InvoiceListFilters => {
  return {
    warehouseId: selectedWarehouses?.value || undefined,
    creditNoteType: creditNoteType?.value || [
      InvoiceCreditNoteType.DEBT_CREDIT,
      InvoiceCreditNoteType.IMPAIRMENT_DEBT_CREDIT,
      InvoiceCreditNoteType.SERVICE_CREDIT,
    ],
    creditedAmount: creditedAmount?.value || undefined,
    creationDateFrom: getFilterServerFormatDate(creationDateFrom?.value),
    creationDateTo: getFilterServerFormatDate(creationDateTo?.value),
    isApplicable: isApplicable?.value === undefined ? undefined : isApplicable?.value === 'applicable',
  };
};
